import type { Project, ProjectCategory, Bi } from '../types'

export const projectFilters: { id: ProjectCategory | 'all'; label: Bi }[] = [
  { id: 'all', label: { en: 'All Projects', es: 'Todos' } },
  { id: 'crawlspace', label: { en: 'Crawl Space', es: 'Crawl Space' } },
  { id: 'waterproofing', label: { en: 'Waterproofing', es: 'Impermeabilización' } },
]

export const projects: Project[] = [
  {
    id: 'crawl-space-shelton',
    category: 'crawlspace',
    serviceSlug: 'crawl-space-encapsulation',
    label: { en: 'Crawl Space Repair', es: 'Reparación de Crawl Space' },
    city: 'Shelton, WA',
    year: 2025,
    description: {
      en: 'Complete crawl space remediation, moisture barrier installation, and professional encapsulation for a 1970s Shelton home with standing water and fallen insulation.',
      es: 'Remediación completa del crawl space, instalación de barrera contra humedad y encapsulado profesional en una casa de Shelton de los años 70 con agua estancada y aislamiento caído.',
    },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/b89f19f0-b1b9-4c4b-8323-6c2505c6b9e3.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/3ff960fe-068f-4c75-9c67-cedcad1e8785.jpg',
    beforeAlt: {
      en: 'Damp dirty crawl space with torn plastic and fallen insulation before repair in Shelton WA',
      es: 'Crawl space húmedo y sucio con plástico roto y aislamiento caído antes de la reparación en Shelton WA',
    },
    afterAlt: {
      en: 'Encapsulated crawl space with clean white vapor barrier after repair in Shelton WA',
      es: 'Crawl space encapsulado con barrera de vapor blanca después de la reparación en Shelton WA',
    },
  },
  {
    id: 'waterproofing-tacoma',
    category: 'waterproofing',
    serviceSlug: 'basement-waterproofing',
    label: { en: 'Basement Waterproofing', es: 'Impermeabilización de Sótano' },
    city: 'Tacoma, WA',
    year: 2024,
    description: {
      en: 'Perimeter drainage, sump pump setup, and a full wall sealing system that ended years of winter flooding in this Tacoma basement.',
      es: 'Drenaje perimetral, bomba de sumidero y sellado completo de muros que terminaron con años de inundaciones invernales en este sótano de Tacoma.',
    },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/fe7582cb-c6c9-42fc-9adc-d173b706780c.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/85d8389c-156b-4884-9b88-ae2bdbe80e71.jpg',
    beforeAlt: {
      en: 'Wet basement with standing water and stained walls before waterproofing in Tacoma WA',
      es: 'Sótano mojado con agua estancada y muros manchados antes de impermeabilizar en Tacoma WA',
    },
    afterAlt: {
      en: 'Dry sealed basement with new sump pump after waterproofing in Tacoma WA',
      es: 'Sótano seco y sellado con bomba de sumidero nueva después de impermeabilizar en Tacoma WA',
    },
  },
]
